import { useEffect, useState } from 'react';

import ModalComponent from '../../components/ModalComponent/ModalComponent';
import { images } from '../../assets/strings/strings';

import './MainPage.css';

import logo from '../../assets/logo-2026-small.png';
import Navbar from '../../components/navbar';
import HeroSection from '../../components/HeroSection';
import Program from '../../components/Program';
import Tickets from '../../components/Tickets';
import QA from '../../components/QA';
import Footer from '../../components/Footer';

const MainPage = () => {
  const [imgCached, setImgCached] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalInfo] = useState({});


  /**
   * Cache images and show loader while doing this
   * @param srcArrays
   * @returns {Promise<void>}
   */
  const cacheImages = async (srcArrays) => {
    const promises = await srcArrays.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.src = src;
        img.onload = resolve();
        img.onerror = reject();
      });
    });

    await Promise.all(promises);
  };

  useEffect(() => {
    cacheImages(images).then(() =>
      setTimeout(() => {
        setImgCached(true);
      }, 800)
    );
  }, []);

  return imgCached ? (
    <div>
      <ModalComponent
        modalIsOpenProp={modalIsOpen}
        setIsOpenProp={setIsOpen}
        masterclassModalInfo={modalInfo}
      ></ModalComponent>

      <Navbar />
      <HeroSection />
      <Program />
      <Tickets />
      <QA />
      <Footer />
    </div>
  ) : (
    <div className="loader">
      <img src={logo} className="" alt={'APPS Masterclasses logo'} />
    </div>
  );
};

export default MainPage;
